import React from 'react'

type Props = {
    task    : {
        id      : ID
        title   : string
    }

    isOpen  : boolean
}

type State = {
    over    : boolean
}

export default class TaskTrayTask extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
            over: false
        }
    }

    onMouseEnter = (e: React.MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()

        this.setState({
            over: true
        })
    }

    onMouseLeave = (e: React.MouseEvent) => {
        this.setState({
            over: false
        })
    }

    onCloseClick = (e: React.MouseEvent) => {
        e.stopPropagation();

        gd.taskTray.remove(this.props.task.id)
    }

    onTaskClick = () => {
        gd.taskView.open(this.props.task.id)
    }

    render() {
        const classes = Classes('task', {
            open: this.props.isOpen
        })

        return (
            <div className={classes} onClick={this.onTaskClick} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                <div className="name">{this.props.task.title}</div>

                {this.state.over &&
                    <div className="i5-delete-circle-solid" onClick={this.onCloseClick}/>}
            </div>
        )
    }
}
